import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";
import { IConversationData } from "../../../helpers/types";
import { CONVERSATIONS_FILTER_TYPES, CONVERSATIONS_TYPES } from "../../../helpers/constant";

export const selectFilteredConversations = createSelector(
  [
    (state: StoreState) => {
      return {
        conversationsData: state.messages.conversationsData,
        unreadConversationsData: state.messages.unreadConversationsData,
        unansweredConversationsData: state.messages.unansweredConversationsData,
        searchConversations: state.messages.searchConversations,
        conversationsType: state.messages.type
      }
    },
    (_state: StoreState, type: string, filter: string) => ({ type, filter })
  ],

  ({ conversationsData, searchConversations, conversationsType, unreadConversationsData, unansweredConversationsData }, { type, filter }) => {
    let conversations: IConversationData | undefined = undefined;

    if (conversationsType === CONVERSATIONS_TYPES.SEARCH) {
      conversations = searchConversations.find((conversation: IConversationData) => conversation.type === type);
    } else if (filter === CONVERSATIONS_FILTER_TYPES.UNREAD) {
      conversations = unreadConversationsData.find((conversation: IConversationData) => conversation.type === type);
    } else if (filter === CONVERSATIONS_FILTER_TYPES.UNANSWERED) {
      conversations = unansweredConversationsData.find((conversation: IConversationData) => conversation.type === type);
    } else {
      conversations = conversationsData.find((conversation: IConversationData) => conversation.type === type);
    }

    return conversations?.data || [];
  }
);

export const selectUnreadTypes = (state: StoreState) => state.messages.unreadTypes;

export const selectConversationsDetails = createSelector(
  [
    (state: StoreState) => {
      return {
        conversationsData: state.messages.conversationsData,
        searchConversations: state.messages.searchConversations,
        unreadConversationsData: state.messages.unreadConversationsData,
        unansweredConversationsData: state.messages.unansweredConversationsData,
        conversationsType: state.messages.type
      }
    },
    (_state: StoreState, type: string, filter: string) => ({ type, filter })
  ],

  ({ conversationsData, searchConversations, unreadConversationsData, unansweredConversationsData, conversationsType }, { type, filter }) => {
    let conversations: IConversationData | undefined = undefined;

    if (conversationsType === CONVERSATIONS_TYPES.SEARCH) {
      conversations = searchConversations.find((conversation: IConversationData) => conversation.type === type);
    } else if (filter === CONVERSATIONS_FILTER_TYPES.UNREAD) {
      conversations = unreadConversationsData.find((conversation: IConversationData) => conversation.type === type);
    } else if (filter === CONVERSATIONS_FILTER_TYPES.UNANSWERED) {
      conversations = unansweredConversationsData.find((conversation: IConversationData) => conversation.type === type);
    } else {
      conversations = conversationsData.find((conversation: IConversationData) => conversation.type === type);
    }

    if (!conversations)
      return { page: 1, hasNextPage: false };

    const hasNextPage = conversations && conversations.data.length > 0 && conversations.page! < conversations.totalPages!

    return { hasNextPage, page: conversations.page! || 1 };
  }
);